import { useDispatch, useSelector } from "react-redux";
import { ReactSVG } from "react-svg";
import { sendMessageToChat } from "../../../../../redux/action/messages/chat/chatAction";
import { useParams } from "react-router-dom";
import { useCookies } from "react-cookie";
import { ADD_TO_LIST_MESSAGES } from "../../../../../redux/action/messages/list/listType";
import {
  ADD_TEXT_MESSAGE_ITEM_TO_CHAT,
  SVAE_MESSAGE_INPUT_USER_IN_CHAT_PAGE,
  ADD_REALTIME_MESSAGE,
} from "../../../../../redux/action/messages/chat/chatType";
import { useEffect, useState } from "react";

const SendMessageBtn = (props) => {
  useEffect(() => {
    if (props.sendChatDelay <= 0) return;
    const interval = setInterval(() => {
      props.setSendChatDelay((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [props.sendChatDelay]);

  return (
    <button
      onClick={props.sendMessage}
      disabled={
        props.error ||
        props.invite ||
        props.loading ||
        props.sendChatDelay !== 0 ||
        props.loadingResponse
      }
      type="submit"
      className={`w-10 h-10 mb-[5px] flex items-center justify-center bg-primary text-white flex-shrink-0 rounded-xl shadow-sm shadow-primary outline outline-2 outline-primary/10 disabled:opacity-50`}
    >
      <ReactSVG
        src={`${process.env.PUBLIC_URL}/assets/images/icons/send.svg`}
        className="w-6 h-6"
      />
    </button>
  );
};

export default SendMessageBtn;
